Drupal.behaviors.modal = () => {
  return {
    modalContent: null,
    isLoading: false,

    fetchModalContent(url, event) {
      event.preventDefault();
      this.isLoading = true;
      fetch(`${url}?_wrapper_format=drupal_dialog`)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          data.forEach((dialog) => {
            if (dialog.command === 'openDialog') {
              this.modalContent = dialog.data.replace('PROJEKT PRO', 'PROJEKT&nbsp;PRO');
              this.isLoading = false;
            } else {
              this.isLoading = false;
              this.modalContent = 'Content not found.';
            }
          });
        });
    },
  };
};
